import React from 'react'

import Widget from '../Widget'
import HorizontalBarChart from '../components/HorizontalBarChart'
import Subtitle from '../../../components/Subtitle'
import Box from '../../../components/Box'
import withFetch from '../../../infrastructure/withFetch'

const buildQuery = (eventId, startDate, endDate) =>
    `/api/sales/get-customers-by-referrer/${eventId}?startDate=${startDate}&endDate=${endDate}`

const Chart = withFetch(
    props => buildQuery(props.eventId, props.startDate, props.endDate),
    ({ status, data, retry }) => (
        <Widget status={status} data={data} retry={retry}>
            <HorizontalBarChart
                data={data.map(d => ({
                    x: d.referrerDomainName,
                    y: d.ticketCount,
                }))}
            />
        </Widget>
    ),
)

const tooltip = (
    <div>
        <p>
            A ticket sold by referrer is counted each time a Customer came to
            the ticket page and eventually made a purchase.
        </p>
        <p>
            If a Customer visits the event page from a link on Oztix, visited
            the event page from a link on the venue’s web site and did a Google
            search for the event page, the number of tickets they purchased will
            be counted 3 times.
        </p>
        <p>
            The purpose is to show sale attribution and all of the referrers who
            played a part in each ticket sold, but this does mean that the
            numbers reported here will not match your total sales and may show
            greater numbers than your actual sales.
        </p>
    </div>
)

const GetByReferrersWidget = ({ eventId, startDate, endDate }) => (
    <div>
        <Subtitle
            title="Referrers that contributed to tickets sold"
            tooltip={tooltip}
        />
        <Box>
            <Chart startDate={startDate} endDate={endDate} eventId={eventId} />
        </Box>
    </div>
)

export default GetByReferrersWidget
